import React, { useState, useEffect } from 'react';
import {
  Button,
  FormGroup,
  Label,
  Input,
  Col,
  Row,
  ModalBody
} from 'reactstrap'
import withReactContent from 'sweetalert2-react-content'
import rotas from 'services/rotas'
import rest from 'lib/rest'
import Swal from 'sweetalert2'
import Loading from 'lib/loading'
import useForm from 'lib/useForm'

const formSwal = withReactContent(Swal)

const DuplicaCampanha = ({fechaModal, listaProdutos}) => {

  const inicialForm = {
    lojas: []
  }

  const [form, onChange, setForm, onChangeSelect, onChangeDate, onChangeCustom, onChangeArray] = useForm(inicialForm)
  const [replicarValor, setReplicarValor] = useState(false)
  const [loading, setLoading]             = useState(true)
  const [lojas, setLojas]                 = useState([])

  const lista = () => {
    try{
    const retorno = rest.get(rotas.lojas)
      retorno.then(ret => {
        if ((ret.success) && (ret.success == 'S') && (ret.lista != '')){
          const novasLojas = []
          for (let i = 0; i < ret.lista.length; i++) {
            let id = ret.lista[i].filial_id
            novasLojas[id] = 'S'
          }
          setForm({ ...inicialForm, lojas: novasLojas })
          setLojas(ret.lista)
        }
        setLoading(false)
      })
      return (true)
    }catch(err){
      setLoading(false)
      return (false)
    }
  }

  const listaCheckbox = lojas.map((loja, index) => {
    return (
      <Row key={loja.filial_id+index}>
      <Col className="p-0" md="12">
        <FormGroup className="m-6" check>
          <Label style={{paddingLeft: '30px'}} check>
            <Input
              type      = "checkbox"
              id        = {"lojasItem" + loja.filial_id}
              key       = {"lojasItem" + loja.filial_id}
              name      = {"lojasItem" + loja.filial_id}
              label     = {loja.nome}
              checked   = {form.lojas[loja.filial_id] == 'S' ? true : false}
              onChange  = {onChangeArray(loja.filial_id, 'lojas')}
            />
            <span className="form-check-sign" />{loja.cnpj +' - '+loja.fantasia}
          </Label>
        </FormGroup>
      </Col>
      </Row>
    )
  })

  const handleReplicarValor = () => { setReplicarValor(!replicarValor) };

  const submitDuplicaCampanha = () => {
    let select = false
    form.lojas.map((loja) => { if (loja == 'S') { select = true } })

    if (!select) {
      formSwal.fire('Loja não selecionada!', 'Por favor, selecione pelo menos uma loja para replicar a lista de produtos.','warning')
      return false
    }

    let dados = {
      'listaProdutos': listaProdutos,
      'listaLojas': form,
      'replicarValor': replicarValor,
    }

    formSwal.queue([{
      title: 'Deseja replicar a lista de produtos para as lojas selecionadas ?',
      confirmButtonText: 'Replicar',
      showCancelButton: true,
      text:'Essas informações serão salvas no banco',
      showLoaderOnConfirm: true,
      cancelButtonColor: '#d33',
      preConfirm: () => {
        const url = rotas.campanha+'replicarProdutosCampanha.php'

        return rest.post(url, dados)
        .then(ret => {
          if (ret.success && ret.success == 'S') {
            formSwal.fire('Salvo! Lista replicada para as lojas.', ret.msg, 'success')
            fechaModal()
          }else{
            formSwal.fire('Erro!', ret.msg, 'error')
          }
        })
      }
    }])
  }

  useEffect(() => {
    lista()
  },[])

  /* Produtos que têm lotes vinculados */
  const produtosComLote = (listaProdutos || []).filter(p => p.lotes_campanha)

  if (loading) {
    return (
      <ModalBody className ="loadingBody">
        <Loading tipo='componente'/>
      </ModalBody>
    )
  }
  return (
    <>
      <ModalBody className="pb-0">
        <FormGroup className="formCadastro">

          {/* Banner de aviso sobre lotes */}
          {produtosComLote.length > 0 && (
            <div style={{
              borderLeft: '4px solid #f59e0b',
              background: '#fffbeb',
              borderRadius: '4px',
              padding: '10px 14px',
              marginBottom: '16px'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                <i className="fa fa-exclamation-triangle" style={{ color: '#d97706', fontSize: 15 }} />
                <strong style={{ color: '#92400e', fontSize: 13 }}>
                  {produtosComLote.length} produto{produtosComLote.length > 1 ? 's' : ''} com lote{produtosComLote.length > 1 ? 's' : ''} vinculado{produtosComLote.length > 1 ? 's' : ''}
                </strong>
              </div>
              <p style={{ margin: '0 0 8px', color: '#78350f', fontSize: 12 }}>
                Os lotes são específicos de cada loja e <strong>não serão replicados</strong>.
                Somente o produto e o preço serão copiados. Após a replicação, acesse cada loja
                e vincule os lotes manualmente se necessário.
              </p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                {produtosComLote.map(p => {
                  let lotes = [];
                  try { lotes = JSON.parse(p.lotes_campanha); } catch (e) {}
                  return (
                    <div key={p.produto_id} style={{ fontSize: 11, color: '#92400e' }}>
                      <span style={{ fontWeight: 700 }}>
                        <i className="fa fa-tag" style={{ color: '#d97706', marginRight: 5 }} />
                        {p.produto}
                      </span>
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 3, marginTop: 3, marginLeft: 18 }}>
                        {lotes.map((lote, i) => {
                          let bg, color, title;
                          if (lote.dias <= 0) {
                            bg = '#f1f5f9'; color = '#94a3b8'; title = 'Vencido';
                          } else if (lote.dias <= 30) {
                            bg = '#fee2e2'; color = '#dc2626'; title = `Vence em ${lote.dias}d`;
                          } else {
                            bg = '#dbeafe'; color = '#1d4ed8'; title = `Vence em ${lote.dias}d`;
                          }
                          return (
                            <span key={i} title={title} style={{
                              fontSize: 10, fontWeight: 700,
                              padding: '1px 5px', borderRadius: 3,
                              background: bg, color
                            }}>
                              {lote.num_lote}
                            </span>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          <Col md='12'>
            {listaCheckbox}
          </Col>
          <hr />
          <Col >
            <FormGroup check inline className="mb-0 mt-0">
              <Label check for="replicarValor">
                <Input
                  id              = "replicarValor"
                  name            = "replicarValor"
                  type            = "checkbox"
                  defaultChecked  = {replicarValor}
                  onChange        = {handleReplicarValor}
                />
                {/* <span className="form-check-sign text-info"><strong>Replicar todos os valores dos produtos.</strong></span> */}
                <span className="form-check-sign text-info"><strong>Replicar valores dos produtos existentes.</strong></span>
              </Label>
            </FormGroup>
          </Col>
          <hr />
          <Col className="text-center p-3">
            <Button type="submit" className="mb-0 mt-0" color="success" size="md"onClick={() => submitDuplicaCampanha()}>
              Replicar
            </Button>
            <Button type="button" className="mb-0 mt-0" color="default" size="md" onClick={() => fechaModal()}>
              Fechar
            </Button>
          </Col>
        </FormGroup>
      </ModalBody>
    </>
  )
  
}

export default DuplicaCampanha
